import { Link, LinkBold, LinkSmall } from "@wix/wix-ui-icons-common";
import { RICOS_ANCHOR_TYPE, RICOS_LINK_TYPE } from "./../ricos-content/index.js";
import {
  createShortcut,
  Decoration_Type,
  quickActionsModalSections,
  RicosPluginToolbarNames
} from "./../ricos-types/index.js";
import { openLinkModal } from "./../_shared/link-modal/open-link-modal.js";
import { toggleLinkModal } from "./../_shared/link-modal/toggle-link-modal.js";
import { isAlwaysVisible } from "./../_shared/resolvers/is-always-visible.js";
import { isLinkOrAnchorInText } from "./../_shared/resolvers/is-link-or-anchor-in-text.js";
import { isNodeSelected } from "./../_shared/resolvers/is-node-selected.js";
import { LinkButton } from "./../toolbars-v3/index.js";
import { anchorConverter } from "./anchor-converter.js";
import { TEXT_BUTTON_LINK } from "./data-hooks.js";
import { DEFAULTS } from "./defaults.js";
import { getToolbarButtons } from "./get-toolbar-buttons.js";
import { linkConverter } from "./link-converter.js";
import { LINK_TYPE } from "./types.js";
const onSave = (publicCommands) => (linkData) => {
  publicCommands.insertDecoration(linkData.anchor ? RICOS_ANCHOR_TYPE : RICOS_LINK_TYPE, linkData);
};
const onSaveMultiple = (publicCommands) => (anchors) => {
  publicCommands.insertMultipleAnchors(anchors);
};
const onUnlink = (publicCommands) => (linkData) => {
  publicCommands.deleteDecoration(linkData.anchor ? RICOS_ANCHOR_TYPE : RICOS_LINK_TYPE);
};
const pluginLink = (config) => {
  const pluginConfig = { ...DEFAULTS.config, ...config };
  const { enabledLinkTypes } = pluginConfig;
  return {
    config: pluginConfig,
    type: LINK_TYPE,
    tiptapExtensions: [],
    pmNodeConverters: [],
    pmMarkConverters: [linkConverter, anchorConverter],
    shortcuts: [
      createShortcut({
        name: Decoration_Type.LINK,
        description: "ShortcutsSheet_Formatting_Link",
        group: "ShortcutsSheet_Section_Formatting",
        keys: {
          macOs: "Meta+K",
          windows: "Ctrl+K"
        },
        enabled: true,
        showInShortcutSheet: true,
        command: ({ publicCommands, modalService, editor }) => {
          openLinkModal({
            editor,
            initialValue: publicCommands.getLinkDataInSelection(),
            modalService,
            onSave: onSave(publicCommands),
            onSaveMultiple: onSaveMultiple(publicCommands),
            onUnlink: onUnlink(publicCommands),
            placement: "bottom-start",
            enabledLinkTypes,
            returnFocusToEditor: true
          });
          return "continue";
        }
      })
    ],
    toolbar: {
      names: [RicosPluginToolbarNames.LINK],
      getButtons: getToolbarButtons,
      isVisible: (selection, editor) => {
        const isSelectionCollapsed = (selection2) => {
          const { from, to } = selection2;
          return to - from <= 0;
        };
        const isCollapsed = isSelectionCollapsed(selection);
        const isLinkInSelection = editor.getPublicCommands().hasLinkInSelection();
        return isCollapsed && isLinkInSelection;
      }
    },
    textButtons: [
      {
        id: Decoration_Type.LINK,
        type: "modal",
        presentation: {
          dataHook: TEXT_BUTTON_LINK,
          tooltip: "TextLinkButton_Tooltip",
          getIcon: (_, __, environment) => environment === "wixel" ? LinkBold : Link
        },
        attributes: {
          visible: isAlwaysVisible,
          active: isLinkOrAnchorInText,
          disabled: isNodeSelected
        },
        Component: LinkButton,
        command: ({ publicCommands, modalService, referenceElement }) => () => {
          toggleLinkModal({
            initialValue: publicCommands.getLinkDataInSelection(),
            modalService,
            onSave: onSave(publicCommands),
            onSaveMultiple: onSaveMultiple(publicCommands),
            onUnlink: onUnlink(publicCommands),
            referenceElement,
            enabledLinkTypes,
            returnFocusToEditor: true
          });
          return true;
        }
      }
    ],
    getQuickActions: ({ pluginServices }) => [
      {
        id: "link",
        title: "QuickActionsPlugin_ActionTitle_Link",
        icon: pluginServices?.context.isMobile ? Link : LinkSmall,
        section: quickActionsModalSections.FormatLayout,
        tags: ["link", "anchor", "url", "hyperlink"],
        command: ({ publicCommands, modalService, editor }) => {
          openLinkModal({
            editor,
            modalService,
            onSaveMultiple: onSaveMultiple(publicCommands),
            onSave: onSave(publicCommands),
            onUnlink: onUnlink(publicCommands),
            placement: "bottom-start",
            enabledLinkTypes,
            returnFocusToEditor: true
          });
        }
      }
    ]
  };
};
export {
  pluginLink
};
//# sourceMappingURL=editor.js.map

import { injectCss } from "./viewer-styles-inject.js";
injectCss();
